import { hosts } from "../yoello-lib/modules/host/Hosts";

export const getCurrencySymbolForLeadSource = (leadSource: string) => {
    switch (leadSource) {
        case hosts.zerobubble:
            return "€";
        case hosts.bna:
            return "$";
        default:
            return "£"
    }
}